export const BODYSHOP_KEY = 'bodyshopState';
